import { auth } from '@/firebase/init';
import { useOrganizationStore } from '@/stores/organizationStore';
import useSidebarStore from '@/stores/sidebarStore';
import { useUserPermissionsStore } from '@/stores/userPermissionsStore';
import { useWorkspaceIdStore } from '@/stores/workspaceIdStore';

export async function logout() {
  useOrganizationStore.getState().reset();
  useUserPermissionsStore.getState().reset();
  useSidebarStore.getState().reset();
  useWorkspaceIdStore.getState().resetWorkspaceId();
  await auth.signOut();
}
